export default __webpack_public_path__ + "static/media/bidAction.24783d14.svg";